import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Material Modules
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatBadgeModule } from '@angular/material/badge';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';

// Components
import { ActivityBookingComponent } from './components/activity-booking/activity-booking.component';
import { ActivityDetailsComponent } from './components/activity-details/activity-details.component';
import { AvailabilityManagementSimpleComponent } from './components/availability-management/availability-management-simple.component';
import { AvailabilityManagementComponent } from './components/availability-management/availability-management.component';
import { ProgramariSimpleComponent } from './components/programari/programari-simple.component';
import { ProgramariComponent } from './components/programari/programari.component';
import { CerereActivityWidgetComponent } from './components/cerere-activity-widget/cerere-activity-widget.component';
import { DashboardCalendarWidgetComponent } from './components/dashboard-calendar-widget/dashboard-calendar-widget.component';
import { ActivityReportsComponent } from './components/activity-reports/activity-reports.component';
import { BulkOperationsComponent } from './components/bulk-operations/bulk-operations.component';

// Services
import { ActivityScheduleService } from './services/activity-schedule.service';
import { ActivityNotificationService } from './services/activity-notification.service';

// Pipes
import { FilterPipe } from './pipes/filter.pipe';

const routes = [
  { path: '', component: ProgramariComponent },
  { path: 'availability', component: AvailabilityManagementComponent },
  { path: 'reports', component: ActivityReportsComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  declarations: [
    ProgramariSimpleComponent,
    ProgramariComponent,
    ActivityBookingComponent,
    ActivityDetailsComponent,
    AvailabilityManagementSimpleComponent,
    AvailabilityManagementComponent,
    CerereActivityWidgetComponent,
    DashboardCalendarWidgetComponent,
    ActivityReportsComponent,
    BulkOperationsComponent,
    FilterPipe
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule.forChild(routes),
    
    // Material Modules
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatChipsModule,
    MatCheckboxModule,
    MatBadgeModule,
    MatListModule,
    MatSidenavModule,
    MatDividerModule
  ],
  providers: [
    ActivityScheduleService,
    ActivityNotificationService
  ],
  exports: [
    AvailabilityManagementSimpleComponent,
    AvailabilityManagementComponent,
    CerereActivityWidgetComponent,
    DashboardCalendarWidgetComponent,
    ActivityReportsComponent,
    BulkOperationsComponent
  ]
})
export class ActivityScheduleModule { }